import Plugin from './plugin';
import './index.css';

export default Plugin;
